module.exports = __webpack_public_path__ + "img/pos6_txt.4e52d08e.png";